import {
  Briefcase,
  Building2,
  Bus,
  Car,
  Factory,
  GraduationCap,
  HeartPulse,
  Home,
  Hotel,
  Landmark,
  Leaf,
  type LucideIcon,
  Receipt,
  Shield,
  Smartphone,
  Store,
  Tag,
  Truck,
  UtensilsCrossed,
  Wallet,
  Waves
} from "lucide-react"

export const TAX_MODULE_ICON_OPTIONS = [
  { value: "Tag", label: "Tag" },
  { value: "Building2", label: "Building" },
  { value: "Wallet", label: "Wallet" },
  { value: "Car", label: "Car" },
  { value: "Home", label: "Home" },
  { value: "Store", label: "Store" },
  { value: "Briefcase", label: "Briefcase" },
  { value: "Receipt", label: "Receipt" },
  { value: "Landmark", label: "Landmark" },
  { value: "Bus", label: "Bus" },
  { value: "Truck", label: "Truck" },
  { value: "UtensilsCrossed", label: "Food" },
  { value: "Hotel", label: "Hotel" },
  { value: "GraduationCap", label: "Education" },
  { value: "HeartPulse", label: "Health" },
  { value: "Shield", label: "Security" },
  { value: "Factory", label: "Industry" },
  { value: "Waves", label: "Water" },
  { value: "Leaf", label: "Environment" },
  { value: "Smartphone", label: "Digital" }
] as const

const ICONS_BY_NAME: Record<string, LucideIcon> = {
  Tag,
  Building2,
  Wallet,
  Car,
  Home,
  Store,
  Briefcase,
  Receipt,
  Landmark,
  Bus,
  Truck,
  UtensilsCrossed,
  Hotel,
  GraduationCap,
  HeartPulse,
  Shield,
  Factory,
  Waves,
  Leaf,
  Smartphone
}

export function taxModuleIconByName(iconName?: string): LucideIcon {
  if (iconName && ICONS_BY_NAME[iconName]) {
    return ICONS_BY_NAME[iconName]
  }

  return Tag
}
